module.exports = __webpack_public_path__ + "static/media/portrait-small.7cd5af87.svg";